
import React, { useState } from "react";
import InputLogo from "../../common/InputLogo/InputLogo";
import Input from "../../common/Input/Input";
import Button from "../../common/Button/Button";
import { Toaster } from "../../common/Toaster/Toaster";
import { useNavigate, useLocation } from "react-router-dom";
import { updatePassword } from "../../service/AuthWellDhanService";

function UpdatePasswordComponent() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { event_type_id } = location.state || {};

  // Optional: Redirect to login if accessed directly
  React.useEffect(() => {
    if (!event_type_id) {
      navigate("/login");
    }
  }, [event_type_id, navigate]);

  const validate = () => {
    if (!password || password.length < 8) return "Password must be at least 8 characters.";
    if (password !== confirmPassword) return "Passwords do not match.";
    return "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    const errMsg = validate();
    if (errMsg) {
      setError(errMsg);
      return;
    }
    setLoading(true);
    const payload = {
      password,
      confirmPassword,
      event_type_id,
    };
    const result = await updatePassword(payload);
    setLoading(false);
    if (result.success) {
      setSuccess("Password updated! Please login.");
      setTimeout(() => {
        navigate("/login");
      }, 1500);
      // If backend returns a new token, store it (optional)
      if (result.data?.access_token) {
        localStorage.setItem("access_token", result.data.access_token);
      }
    } else {
      setError(result.message || "Failed to update password.");
    }
  };

  return (
    <div className="w-full flex justify-center items-center min-h-screen">
      {error && <Toaster message={error} type="error" />}
      {success && <Toaster message={success} type="success" />}
      <div className="bg-app-bg w-full max-w-md mx-auto rounded-2xl shadow-lg p-8 flex flex-col items-center">
        <InputLogo text="Update Password" />
        <form className="w-full flex flex-col gap-4 items-center" onSubmit={handleSubmit}>
          <Input
            name="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter new password"
            className="w-full bg-input-bg"
            type="password"
            required
          />
          <Input
            name="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Confirm new password"
            className="w-full bg-input-bg"
            type="password"
            required
          />
          <Button
            type="submit"
            text={loading ? "Updating..." : "Update Password"}
            className="bg-orange-primary text-white w-full rounded-lg mt-4 py-2 text-lg font-semibold"
            disabled={loading}
          />
        </form>
        <div className="w-full text-center mt-4 text-xs">
          <span
            className="text-orange-primary cursor-pointer underline"
            onClick={() => navigate("/login")}
          >
            Back to Login
          </span>
        </div>
      </div>
    </div>
  );
}

export default UpdatePasswordComponent;
